// TalkToSupportButton — one tap from Home to "Talk to support" (the in-app
// voice/typed call, src/components/SupportCall.tsx). The ⌘K palette's
// "Talk to support…" opens the same panel; this saves opening the palette and
// searching first (Thomas, 22 Oct 2026).
//
// Hidden in support view, like the palette row: a support call is about your
// OWN business, and support-voice-session refuses one there anyway.

import { Headset } from 'lucide-react'
import { openSupportCall } from '@/components/SupportCall'
import { useSupportView } from '@/lib/platformView'

export function TalkToSupportButton() {
  const inSupportView = useSupportView()
  if (inSupportView) return null
  // A small icon beside the search box: the same chip shape as Search / Go to,
  // without words, so the header stays one row.
  return (
    <button type="button" onClick={() => openSupportCall()} aria-label="Talk to support"
      title="Talk to support: ask out loud, and she rings the buttons to tap"
      className="rounded-xl surface hover:bg-emerald-500/15 border hairline-strong px-2.5 py-1.5 coarse:min-h-[44px] coarse:min-w-[44px] inline-flex items-center justify-center transition-colors">
      <Headset size={16} className="text-emerald-400" aria-hidden="true" />
    </button>
  )
}
